const isSupportedLocale = (supportedLocales, urlLocale) => {
  // eslint-disable-next-line no-restricted-syntax -- Enable
  for (const supportedLocale of supportedLocales) {
    if (supportedLocale.toLowerCase() === urlLocale) {
      return true;
    }
  }

  return false;
};

export const localeSpecificRedirectHook = (supportedLocales) => (nextState, replace, callback) => {
  if (!isSupportedLocale(supportedLocales, nextState.params.locale)) {
    replace(`/${nextState.params.locale}/travel`);
  }

  return callback();
};
